import { gql } from '@apollo/client'

import { OPERATING_HOUR_FRAGMENT } from './operatingHour'

export const OPERATING_DAY_FRAGMENT = gql`
  fragment OperatingDay on OperatingDayInterface {
    id
    operatingHours {
      ...OperatingHour
    }
  }

  ${OPERATING_HOUR_FRAGMENT}
`
